import { ValidationGenerator } from "../../../form/validation/validation-generator"
import { UserValidationSetting } from "../../../form/validation/validation-setting"
import { UpdateUserInput } from "../../../rpcs/dist/UserRPC"

export type IFormField = NonNullable<UpdateUserInput["password"]>

export const validate = (values: Partial<IFormField>) => {
  const errors: Partial<IFormField> = {}

  const UserCurrentPasswordVal = ValidationGenerator(
    values.currentPassword,
    UserValidationSetting.password,
  )
  const UserNewPasswordVal = ValidationGenerator(
    values.newPassword,
    UserValidationSetting.password,
  )
  const UserNewPasswordForConfirmationVal = ValidationGenerator(
    values.newPasswordForConfirmation,
    UserValidationSetting.password,
  )

  if (UserCurrentPasswordVal) {
    errors.currentPassword = UserCurrentPasswordVal
  }

  if (UserNewPasswordVal) {
    errors.newPassword = UserNewPasswordVal
  }

  if (UserNewPasswordForConfirmationVal) {
    errors.newPasswordForConfirmation = UserNewPasswordForConfirmationVal
  }

  if (values.newPassword !== values.newPasswordForConfirmation) {
    errors.newPasswordForConfirmation =
      "パスワードとパスワード確認が一致しません。"
  }

  return errors
}
